// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3UQb_","list":"BalanceDue_list__1GzF_","listRow":"BalanceDue_listRow__2F5Xf","total":"BalanceDue_total__2KjdQ"};